import React from 'react';
import { Link } from 'react-router-dom';

import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
`;

const Icon = styled.img`
  width: 34px;
  height: 34px;
  margin-bottom: 20px;
`;

const Title = styled.h1`
  font-family: var(--font-fancy);
  font-size: 42px;
  font-weight: normal;
  color: var(--text-secondary);
  margin: 0;
`;

const ContentBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: max-content;
  max-width: 100%;
`;

const Divider = styled.div`
  position: relative;
  width: 100%;
  border-top: 1px solid var(--line-gray);
  margin: 25px 0;

  &::after {
    content: '';
    position: absolute;
    top: -4px;
    left: 50%;
    transform: translateX(-50%);
    width: 7px;
    height: 7px;
    border-radius: 50%;
    border: 1px solid var(--line-gray);
    background-color: #ffffff;
  }
`;

const Description = styled.div`
  text-align: center;
  font-size: 21px;
  font-weight: normal;
  line-height: 1.43;
  color: var(--text-secondary);

  a {
    font-weight: normal;
    color: var(--dark-blue);
  }
`;

const CmiDigestThankYou = () => (
  <Container>
    <Icon src="/icons/checkmark.svg" alt="" />
    <Title>Thank you!</Title>
    <ContentBlock>
      <Divider />
      <Description>
        We are glad we got your preferences right.
        <br />
        You can always come back and <Link to="/preferences/cmi-digest">edit preferences</Link>.
      </Description>
    </ContentBlock>
  </Container>
);

export default CmiDigestThankYou;
